// extracted by mini-css-extract-plugin
export default {"configblog":"ce4bb1eac52930048546"};